import { ApiKeyFetch } from 'api/fetchers/apiKey';
import { URL_BASE_PHP_8 } from 'constants/urls';
import useCustomRouter from 'hooks/useCustomRouter';
import useCustomToast from 'hooks/useCustomToasts';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';

const URL_VERIFICAR_ESTADO_COMPRA = `${URL_BASE_PHP_8}api/v1/internal/validacion/verificar-estado-compra`;

const useIsCompraFinalizada = ({ id, ramo, redirectOnPolizaFinalizada = true, redirectOnPolizaPagada = true }) => {
  const API = useMemo(() => ApiKeyFetch.instance(), []);
  const [isLoading, setIsLoading] = useState(false);
  const [active, setActive] = useState(true);

  const { addInfoToast } = useCustomToast();

  const router = useCustomRouter();

  useIdleTimer({
    onIdle: () => {
      console.log('IDLE');
      setActive(false);
    },
    onActive: () => {
      console.log('ACTIVE');
      setActive(true);
    },
    timeout: 60_000 * 10,
    // timeout: 10_000,
    throttle: 10_000,
  });

  const verificarEstado = useCallback(async () => {
    if (active === false || isLoading || !id || !ramo) return;
    console.log('VERIFICAR ESTADO: ', id, ramo);
    setIsLoading(true);
    try {
      const response = await API.post(URL_VERIFICAR_ESTADO_COMPRA, {
        id,
        ramo,
      });

      if (response.transaccion === true && response?.data?.existePoliza === true) {
        if (redirectOnPolizaFinalizada && response.data.polizaEmitida === true) {
          addInfoToast(
            `La compra con el fólio ${response.data.folio} y número ${response?.data?.numeroPoliza} ya se encuentra finalizada, no es posible modificar sus valores`,
            {
              autoDismiss: false,
            }
          );
          router.push('/');
          return;
        }
        if (redirectOnPolizaPagada && response.data.polizaPagada === true) {
          addInfoToast(
            `La compra con el fólio ${response.data.folio} ya se encuentra pagada, no es posible modificar sus valores`,
            {
              autoDismiss: false,
            }
          );
          router.push('/');
          return;
        }
      }
    } catch (error) {
      console.error('Error during verification:', error);
    } finally {
      setIsLoading(false);
    }
  }, [active, isLoading, id, ramo]); // 1000 ms de throttling

  const handleVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      verificarEstado();
    }
  };

  const handleClick = (event) => {
    if (event.target.tagName === 'BUTTON') {
      verificarEstado();
    }
  };

  useEffect(() => {
    verificarEstado();
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      console.log('INTERVAL: ');
      verificarEstado();
    }, 60000); // 60 segundos
    // }, 10000); // 60 segundos

    document.addEventListener('visibilitychange', handleVisibilityChange);
    document.addEventListener('click', handleClick);

    return () => {
      clearInterval(intervalId);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      document.removeEventListener('click', handleClick);
    };
  }, [verificarEstado]);

  return null;
};

export default useIsCompraFinalizada;
